<template>
    <scrollactive offset=53 v-on:itemchanged="onItemChanged">
        <navbar
                position="fixed"
                type="default"
                :transparent="transparent"
                :color-on-scroll="colorOnScroll"
                menu-classes="ml-auto"
        >
            <template>
                <router-link v-popover:popover1 class="navbar-brand" to="/">
                    Anja's Fußpflege
                </router-link>
            </template>
            <template slot="navbar-menu">

                <!--<li class="nav-item">-->
                <!--v-scroll-to="'#uebermich'"       v-bind:class="{ active: $store.getters.activeContentDIV === 'uebermich' }"-->
                <a
                        class="scrollactive-item nav-link" href="#uebermich"
                >
                    <p>Über Mich</p>
                </a>
                <a
                        class="scrollactive-item nav-link" href="#aktuelles"
                >
                    <p>Aktuelles</p>
                </a>

                <a
                        class="scrollactive-item nav-link" href="#angebotpreise"
                >
                    <p>Angebot & Preise</p>
                </a>

                <!--<a
                        class="scrollactive-item nav-link" href="#produkte"
                >
                    <p>Produkte</p>
                </a>-->

                <a
                        class="scrollactive-item nav-link" href="#termin"
                >
                    <p>Termin</p>
                </a>

                <a
                        class="scrollactive-item nav-link" href="#kontaktanfahrt"
                >
                    <p>Kontakt & Anfahrt</p>
                </a>

                <a
                    class="scrollactive-item nav-link" href="#studio"
                >
                  <p>Studio</p>
                </a>

            </template>

        </navbar>
    </scrollactive>
    <!--
        <scrollactive class="my-nav" click-to-scroll="true">
            <a href="#uebermich" class="scrollactive-item">Home</a>
            <a href="#aktuelles" class="scrollactive-item">About Us</a>
            <a href="#portfolio" class="scrollactive-item">Portfolio</a>
            <a href="#contact" class="scrollactive-item">Contact</a>
        </scrollactive>-->

    <!--<navbar
            position="fixed"
            type="info"
            :transparent="transparent"
            :color-on-scroll="colorOnScroll"
            menu-classes="ml-auto"
    >
        <template>
            <router-link v-popover:popover1 class="navbar-brand" to="/">
                Anja's Fußpflege
            </router-link>
        </template>
        <template slot="navbar-menu">
            <scrollactive class="my-nav">
                <li>
                    <a href="#uebermich" class="scrollactive-item">Home</a>
                </li>
                <li>
                    <a href="#aktuelles" class="scrollactive-item">About Us</a>
                </li>
                <li>
                    <a href="#portfolio" class="scrollactive-item">Portfolio</a>
                </li>
                <li>
                    <a href="#contact" class="scrollactive-item">Contact</a>
                </li>
            </scrollactive>
        </template>
    </navbar>-->
</template>

<script>
    import {Navbar} from '@/components';
    import {Popover} from 'element-ui';


    export default {
        name: 'main-navbar',
        props: {
            transparent: Boolean,
            colorOnScroll: Number
        },
        components: {
            Navbar,
            [Popover.name]: Popover
        },
        methods: {
            onItemChanged(/*event, currentItem, lastActiveItem*/) {
                // here you have access to everything you need regarding that event
                //console.log("nicht vergessen zu implementieren");
            }
        },
        data: () => ({
            //activeNav: activeNav
        })
    };
</script>

<style scoped></style>
